import { MediaFilesController as MediaFilesControllerClass } from "@scrile/tools/dist";
import config from "config";

export const MediaFilesController = new MediaFilesControllerClass({
  s3Url: config.s3Url,
  thumbnailUrl: config.thumbnailUrl,
  videoThumbnailUrl: config.videoThumbnailUrl,
});
